import * as fabric from 'fabric';
import { SnappableMixin } from './snappable';

export class SnappyImage extends SnappableMixin(fabric.FabricImage) {}
